var map = {
	"./Allowance.svg": 65635,
	"./Exit.svg": 93755,
	"./PPE.svg": 48324,
	"./Personnel.svg": 64373,
	"./Salary.svg": 8485,
	"./Timesheet.svg": 22073,
	"./Training.svg": 97953,
	"./Vacation.svg": 53202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;